(function() {
	var App = angular.module('pphhApp');

	App
		.controller("pphhNavController", ["$scope", "$window", "$mdDialog", "$mdToast",
			"$http", "$injector", "CRUDService", "CommonCatalogService", "SessionStorageService",
			"pphhEnv", PPHHNavController])
		.controller("lookupSourceControllerDispatcher", ["$scope", "$controller", "$mdDialog",
			"$http", "entity", "fieldName", "multiple", "selectedValues", "currentViewType",
			LookupSourceControllerDispatcher])
		.controller("moduleCarouselController", ["$scope", "CRUDService", ModuleCarouselController])
		.controller("moduleIndexController", ["$scope", "$window", "$http", "pphhEnv", "module",
			ModuleIndexController])
		.controller("storedFilterController", ["$scope", "$mdDialog", "CRUDService", "storedFilters",
			"waterModule", StoredFilterController])
		.controller("newStoredFilterController", ["$scope", "$mdDialog", NewStoredFilterController])
		.controller("activityInfoController", ["$scope", "$mdDialog", "activity", ActivityInfoController])
		.controller("fieldTraceController", ["$scope", "fieldTrace", "field", FieldTraceController])
		.controller("uploadImagenController", ["$scope", "$mdDialog", "CRUDService", UploadImagenController]);
	
		function PPHHNavController($scope, $window, $mdDialog, $mdToast,
		$http, $injector, crudService, commonCatalogService, sessionStorageService, pphhEnv) {
			
		var MODULE_ENDPOINT_KEY = "moduleEndpoint";

		// Memora interna
		var initializing = false;
		var postInitActions = [];

		var presetPaginationStart = null;
		var presetSort = null;

		// Memoria compartida
		$scope.cicloId = null;
		$scope.lockedCiclo = true;

		$scope.waterModule = null;

		$scope.errorMessages = [];
		$scope.errorMessagesCollapsed = true;

		$scope.showActivities = false;
		$scope.activities = [];
		$scope.currentActivity = null;


		$scope.currentViewType = null;
		$scope.viewTitle = null; // Título de la vista

		$scope.entity = { // Instancia sobre la que se trabaja
			id: null,
			entityName: null,
			filter: {},
			form: {},
			compositions: {},
			externals: {},
			readonly: true
		};

		$scope.filterResults = []; // Resultados del filtro
		$scope.menusResults = [];
		$scope.itemsByPage = 25;

		$scope.isLoading = false;

		$scope.filtersCollapsed = true;

		$scope.breadcrumbs = []; // Miga de pan

		$scope.menu = {};
		$scope.menuRows = [];

		$scope.storedFilters = [];

		// Métodos
		$scope.init = init;

		$scope.expandMessages = function(expand) {
			$scope.errorMessagesCollapsed = !expand;
		};

		/**
		 * Permite la contracción y expansión de los criterios de filtrado
		 */
		$scope.expandFilters = function(expand) {
			$scope.filtersCollapsed = !expand;
		};
		$scope.filterCount = filterCount;
		$scope.filterInfo = filterInfo;
		$scope.filter = filter;
		$scope.doFilter = doFilter;
		$scope.clearFilter = clearFilter;
		$scope.filterResultRowClasses = filterResultRowClasses;
		$scope.showStoredFilters = showStoredFilters;
		$scope.storeFilter = storeFilter;
		$scope.findStoredFilterById = findStoredFilterById;
		$scope.findStoredFilterByEntityName = findStoredFilterByEntityName;
		$scope.findStoredFilterByFilterField = findStoredFilterByFilterField;
		$scope.applyStoredFilter = applyStoredFilter;
		$scope.clearStoredFilter = clearStoredFilter;
		$scope.limpiarVacio =limpiarVacio;
		$scope.filtroVacio = filtroVacio;

		$scope.showBreadCrumb = showBreadCrumb;
		$scope.showBreadCrumbSeparator = showBreadCrumbSeparator;
		$scope.navigateBreadcrumb = function(index) {
			$window.location.href = pphhEnv.global.contextPath + "/pphhNav/breadcrumb/" + index;
		};
		$scope.navigateBackBreadcrumb = function() {
			var index = $scope.breadcrumbs.length - 2;
			$scope.navigateBreadcrumb(index);
		};

		$scope.showModuleIndex = showModuleIndex;

		$scope.initNew = initNew;
		$scope.saveInstance = saveInstance;
		$scope.deletePreconditions = deletePreconditions;

		$scope.getActivityInstanceTrace = getActivityInstanceTrace;
		$scope.hasFieldChangedByActivity = hasFieldChangedByActivity;
		$scope.showFieldChangesByActivity = showFieldChangesByActivity;
		$scope.filterByActivity = filterByActivity;
		$scope.clearFilterByActivity = clearFilterByActivity;
		$scope.activityInfo = activityInfo;
		$scope.getActivityEntitySummary = getActivityEntitySummary;
		$scope.closeActivity = closeActivity;
		$scope.showActivityHelp = showActivityHelp;
		$scope.showActivityList = showActivityList;
		$scope.startActivity = startActivity;
		$scope.activityTransition = activityTransition;

		$scope.getRowMenu = getRowMenu;
		$scope.executeRowMenuOption = executeRowMenuOption;
		$scope.executeMenuOption = executeMenuOption;
		$scope.lookupSource = lookupSource;

		$scope.changeViewMode = changeViewMode;

		$scope.showModuleCarousel = showModuleCarousel;

		/**
		 * Se encarga de iniciar el controlador con la entidad seleccionada en cada momento.
		 */
		function init(cicloId, activityId, adminModeOn, waterModule, entityName, id, viewType) {
			initializing = true;
			loadModuleGlobalMenu();

			crudService.getStoredFilters().then(function(response) {
				$scope.storedFilters = response.data;
			});

			crudService.navIndex().then(function(response) {
				$scope.navIndex = response.data;
			});

			commonCatalogService.getWaterModule(waterModule)
				.then(function(response) {
					$scope.waterModule = response.data;
					loadActivityList(activityId);
				});

			$scope.cicloId = cicloId;
			$scope.lockedCiclo = "true" === adminModeOn;

			$scope.currentViewType = viewType;

			$scope.entity.entityName = entityName;

			if (viewType === "listView") {
				crudService.initFilter($scope.entity.entityName)
					.then(listViewSuccessCallback, listViewErrorCallback)
					.then(recallEndpoint)
					.then(function() {
						initializing = false;
						doPostInitActions();
					});
			}
			else {
				$scope.entity.id = (id !== "") ? id : null;

				crudService.initForm($scope.entity.entityName, id)
					.then(formViewSuccessCallback, formViewErrorCallback);
			}
		}

		function loadModuleGlobalMenu() {
			crudService.menu().then(function(response) {
				$scope.menu = response.data;
			});
		}

		function registerPostInitActions(action) {
			var findCallback = function(otherAction) {
				return otherAction.fn == action.fn;
			};

			var found = false;
			for (var i = 0; !found && i < postInitActions.length; i++) {
				found = findCallback(postInitActions[i]);
			}
			if (!found) {
				postInitActions[postInitActions.length] = action;
			}
		}

		function doPostInitActions() {
			for (var i = 0; i < postInitActions.length; i++) {
				var action = postInitActions[i];
				action.fn.apply(this, action.params);
			}
			postInitActions = [];
		}

		/**
		 * Carga la información del filtro.
		 */
		function listViewSuccessCallback(response) {
			var crudFilter = response.data.filter;

			$scope.entity.filter = {
				persistenceAvailable: false,
				fields: {}
			};

			var entityFilter = $scope.entity.filter;
			entityFilter.persistenceAvailable = crudFilter.persistenceAvailable;

			var fields = crudFilter.fields;
			for (var i = 0; i < fields.length; i++) {
				var field = fields[i];

				entityFilter.fields[field.name] = field;

				if (field.value != null) {
					if (field.type === "java.util.Date") {
						field.value = moment(field.value).toDate();
						if (field.upperValue != null) {
							field.upperValue = moment(field.value).toDate();
						}
					}
				}
				
				//field.description puede venir como un string al volver del detalle de registro
				//y deberia ser siempre un array
				if(field.description != null){
					var descriptionArr = field.description.split('#');
					field.description = descriptionArr;
				}
			}

			if (response.data.pagination_start) {
				presetPaginationStart = response.data.pagination_start;
			}
			if (response.data.sort_predicate && response.data.sort_asc) {
				presetSort = {};
				presetSort.predicate = response.data.sort_predicate;
				presetSort.reverse = "asc" !== response.data.sort_asc;
			}

			$scope.entity.module = response.data.module;
			$scope.entity.readonly = response.data.readonly;
			$scope.entity.editable = response.data.editable;
			$scope.entity.addable = response.data.addable;

			$scope.viewTitle = response.data.displayLabel;

			$scope.breadcrumbs = response.data.crudBreadcrumbs;

			return response;
		}

		function recallEndpoint() {
			var endpoint = sessionStorageService.getObj(MODULE_ENDPOINT_KEY);			
			if (endpoint && endpoint.entityName === $scope.entity.entityName) {
				var field = $scope.entity.filter.fields[endpoint.fieldName];
				field.value = endpoint.fieldValues;
				field.comparisionType = "EQ";
			}
			
			sessionStorageService.remove(MODULE_ENDPOINT_KEY);
		}

		function listViewErrorCallback() {
			$mdDialog.show(
				$mdDialog.alert({
					title: UIMessages.dialog.confirm.title,
					textContent: "Error list view",
					ok: UIMessages.dialog.confirm.cerrar
				}));
			initializing = false;
		}

		/*
		 * Carga las fuentes de información de los campos.
		 */
		function formViewSuccessCallback(response) {
			var crudInstance = response.data.instance;
			$scope.entity.module = crudInstance.module;
			$scope.entity.readonly = crudInstance.viewMode === "READ_ONLY";
			$scope.entity.editable = findInArray(crudInstance.permissions, function(ele) {
				return ele.key === "write";
			});

			var form = crudInstance.form;
			fillupFormFromInstance(form);

			$scope.entity.externals = crudInstance.externals;

			$scope.viewTitle =
				crudInstance.instanceDisplayLabel
				|| crudInstance.entityDisplayLabel + " " + UIMessages.visor.newInstance;

			setCurrentActivity(response.data.activityId);

			$scope.breadcrumbs = response.data.crudBreadcrumbs;

			initializing = false;
		}

		function fillupFormFromInstance(form) {
			$scope.entity.form = {};
			for (var i = 0; i < form.fields.length; i++) {
				var field = form.fields[i];

				if (field.type === "java.util.Date" && field.value != null) {
					field.value = moment(field.value).toDate();
				}

				$scope.entity.form[field.name] = field;

				if (field.onChangeCallback) {
					onFieldChange(field);
				}
			}
		}

		function onFieldChange(watchedField) {

			function onFieldChangeSuccessCallback(response) {
				var instance = response.data;
				var form = instance.form;

				for (var i = 0; i < form.fields.length; i++) {
					var field = form.fields[i];
					if (field.name === watchedField.name) {
						continue;
					}

					if (field.type === "java.util.Date") {
						field.value = moment(field.value).toDate();
					}

					var oldValue = $scope.entity.form[field.name].value;
					if ((oldValue == null && field.value != null)
						|| (oldValue != null && field.value == null)
						|| oldValue !== field.value) {
						$scope.entity.form[field.name].value = field.value;
						$scope.entity.form[field.name].description = field.description;
					}
					$scope.entity.form[field.name].inlineHelp = field.inlineHelp;
				}

				$scope.isLoading = false;
			}

			function onFieldChangeErrorCallback() {
				$mdDialog.show(
					$mdDialog.alert({
						title: UIMessages.dialog.confirm.title,
						textContent: "OnChange ko",
						ok: UIMessages.dialog.confirm.cerrar
					}));
				$scope.isLoading = false;
			}

			$scope.$watch("entity.form." + watchedField.name + ".value", function(newValue, oldValue) {
				if ((oldValue == null && newValue == null)
					|| oldValue === newValue) {
					return;
				}

				$scope.isLoading = true;
				crudService.onChange($scope.entity.entityName, $scope.entity.id,
					$scope.entity.form, watchedField.name)
					.then(onFieldChangeSuccessCallback, onFieldChangeErrorCallback);
			});
		}

		function findInArray(array, callback) {
			for (var i = 0; i < array.length; i++) {
				if (callback(array[i])) {
					return array[i];
				}
			}

			return null;
		}

		function formViewErrorCallback() {
			$mdDialog.show(
				$mdDialog.alert({
					title: UIMessages.dialog.confirm.title,
					textContent: "Error form view",
					ok: UIMessages.dialog.confirm.cerrar
				}));
			initializing = false;
		}

		function saveInstance() {
			if (!$scope.instanceForm.$valid) {
				return;
			}

			$window.scrollTo(0, 0);

			$scope.isLoading = true;

			crudService.saveInstance($scope.entity.entityName, $scope.entity.id, $scope.entity.form)
				.then(saveInstanceSuccessCallback, saveInstanceErrorCallback);
		}

		/**
		 * Callback que se invoca cuando la operación de guardado se ha realizado
		 * correctamente.
		 */
		function saveInstanceSuccessCallback(response) {
			$scope.entity.id = response.data.id;
			$scope.errorMessages = response.data.errorMessages;

			showToast(response.data.toastLabel);

			// TODO Optimizar esta recarga
			loadActivityList(response.data.activityId);

			crudService.initForm($scope.entity.entityName, $scope.entity.id)
				.then(formViewSuccessCallback, formViewErrorCallback);

			$scope.isLoading = false;
		}

		function showToast(toastLabel) {
			var toast = $mdToast.simple().textContent(toastLabel);
			toast.position("top right");
			toast.parent(document.querySelector("#pphhNavContainer"));
			$mdToast.show(toast);
		}
		
		/**
		 * Callback que se invoca cuando se ha producido algún error durante la
		 * operación de guardado.
		 */
		function saveInstanceErrorCallback(response) {
			if (response.status === 406) {
				$scope.errorMessages = response.data.errorMessages;
				showToast(response.data.toastLabel);
			} else {
				$mdDialog.show(
					$mdDialog.alert({
						title: UIMessages.dialog.confirm.title,
						textContent: "Error save",
						ok: UIMessages.dialog.confirm.cerrar,
						multiple: true
					}));
			}

			$scope.isLoading = false;
		}

		/**
		 * Determina si se puede llevar a cabo el borrado de la instancia y si ésta tiene
		 * registros relacionados que se pueden eliminar en cascada y solicita en su caso 
		 * la confirmación del usuario para continuar.
		 */
		function deletePreconditions(row) {
			$scope.isLoading = true;

			crudService.deletePreconditions($scope.entity.entityName, row.data.id)
				.then(
					function(response) {
						deletePreconditionsSuccessCallback(row.data.id, response);
					},
					deletePreconditionsErrorCallback);
		}

		function deletePreconditionsSuccessCallback(selectedRowId, response) {
			$scope.isLoading = false;

			var preconditions = response.data;
			var alert;
			if (preconditions.noPermission) {
				alert = $mdDialog.alert({
					title: UIMessages.dialog.info.title,
					textContent: UIMessages.crud.deletion.noPermission,
					ok: UIMessages.dialog.confirm.cerrar,
					multiple: true
				});

				$mdDialog.show(alert);
			} else {
				if (preconditions.hasChildren === false && preconditions.hasRecordSubSetRelations === false) {
					alert = $mdDialog.confirm({
						title: preconditions.dialog.title,
						textContent: preconditions.dialog.textContent,
						ok: preconditions.dialog.ok,
						cancel: preconditions.dialog.cancel,
						multiple: true
					});
	
					$mdDialog.show(alert)
						.then(function() {
							crudService.deleteInstance($scope.entity.entityName, selectedRowId)
								.then(deleteInstanceSuccessCallback, deleteInstanceErrorCallback);
						});
				} else if (preconditions.cascadeRemove === false && preconditions.hasRecordSubSetRelations === false) {
						alert = $mdDialog.alert({
							title: preconditions.dialog.title,
							textContent: preconditions.dialog.textContent,
							ok: preconditions.dialog.ok,
							multiple: true
						});
	
						$mdDialog.show(alert);
				} else if (preconditions.hasRecordSubSetRelations) {
						alert = $mdDialog.alert({
							title: preconditions.dialog.title,
							textContent: preconditions.dialog.textContent,
							ok: preconditions.dialog.ok,
							multiple: true
						});
	
						$mdDialog.show(alert);
				} else {
						alert = $mdDialog.confirm({
							title: preconditions.dialog.title,
							textContent: preconditions.dialog.textContent,
							ok: preconditions.dialog.ok,
							cancel: preconditions.dialog.cancel,
							multiple: true
						});
	
						$mdDialog.show(alert)
							.then(function() {
								crudService.deleteInstance($scope.entity.entityName, selectedRowId)
									.then(deleteInstanceSuccessCallback, deleteInstanceErrorCallback);
							});
				}
			}
		}

		function deletePreconditionsErrorCallback() {
			$scope.isLoading = false;
		}

		function deleteInstanceSuccessCallback(response) {
			var payload = response.data;
			$scope.errorMessages = payload.errorMessages;

			if (payload.activityId > 0
				&& $scope.entity.filter.fields.actividadId
				&& payload.activityId !== $scope.entity.filter.fields.actividadId.value) {
				// Se refresca los criterios de filtrado para adaptarlos a la actividad creada
				crudService.initFilter($scope.entity.entityName)
					.then(listViewSuccessCallback, listViewErrorCallback)
					.then(function() {
						reloadListViewAfterDeletion(payload);
					}).then(function() {
						initializing = false;
						doPostInitActions();
					});

			} else {
				reloadListViewAfterDeletion(payload);
			}
		}

		function reloadListViewAfterDeletion(deletionPayload) {
			doFilter();

			// TODO Optimizar esta recarga
			loadActivityList(deletionPayload.activityId);
		}

		function deleteInstanceErrorCallback(response) {
			if (response.status === 406) {
				$scope.errorMessages = response.data.errorMessages;
				showToast(response.data.toastLabel);
			} else {
				$mdDialog.show(
					$mdDialog.alert({
						title: UIMessages.dialog.confirm.title,
						textContent: "Error delete",
						ok: UIMessages.dialog.confirm.cerrar
					}));
			}

			$scope.isLoading = false;
		}

		// Funciones públicas

		/**
		 * Contabiliza los criterios de filtrado de usuario ignorando los implícitos.
		 */
		function filterCount() {
			var count = 0;
			var filters = $scope.entity.filter.fields;
			angular.forEach(filters, function(p) {
				if (p.name !== "actividadId"
					&& p.name !== "cicloId"
					&& ((p.value != null && p.value !== "")
						|| (p.upperValue != null && p.upperValue !== "")
						|| p.storedFilterKey != null)) {
					count++;
				}
			});

			return count;
		}

		function filterInfo() {
			var filterData = {};
			if ($scope.stCtrl) {
				var tableState = $scope.stCtrl.tableState();
				if (tableState.pagination.totalItemCount > 0) {
					filterData.start = tableState.pagination.start || 0;
					filterData.end = filterData.start + tableState.pagination.number;
					if (filterData.end > tableState.pagination.totalItemCount) {
						filterData.end = tableState.pagination.totalItemCount;
					}
					filterData.totalItemCount = tableState.pagination.totalItemCount || 0;
				}
			}
			return filterData;
		}

		function showBreadCrumb(index) {
			var begin = $scope.breadcrumbs.length - 4;
			if (begin < 0) {
				begin = 0;
			}
			if (index >= begin) {
				return true;
			}
			return false;
		}

		function showBreadCrumbSeparator(index) {
			var begin = $scope.breadcrumbs.length - 4;
			if (begin < 0) {
				begin = 0;
			}
			if (index > begin) {
				return true;
			}
			return false;
		}

		/**
		 * Carga la información sobre las actividades pendientes del usuario.
		 */
		function loadActivityList(activityId) {
			$http.get("/dashboard/activeTasks", { params: { module: $scope.waterModule.key } })
				.then(
					function(response) {
						$scope.activities = response.data;
						setCurrentActivity(activityId);
					}
				);
		}

		function setCurrentActivity(activityId) {
			$scope.currentActivity = null;
			if (activityId != 0) {
				for (var i = 0; i < $scope.activities.length; i++) {
					var activity = $scope.activities[i];
					if (activity.id == activityId) {
						$scope.currentActivity = activity;
						break;
					}
				}

				if ($scope.currentActivity != null) {
					$http.get("/pphhNav/activity/" + activityId)
						.then(
							function(response) {
								$scope.currentActivity.summary = response.data.summary;
							}
						);
				}

				if ($scope.currentActivity != null && $scope.entity.id != null) {
					$http.get("/pphhNav/activity/" + activityId
						+ "/i/" + $scope.entity.entityName + "/" + $scope.entity.id)
						.then(
							function(response) {
								$scope.currentActivity.instanceTrace = response.data;
							}
						);
				}
			}
		}

		function getActivityEntitySummary() {
			if ($scope.currentActivity != null && $scope.currentActivity.summary) {
				var summary = $scope.currentActivity.summary;
				for (var i = 0; i < summary.entitySummary.length; i++) {
					var entitySummary = summary.entitySummary[i];
					if ($scope.entity.entityName === entitySummary.entityName) {
						return entitySummary;
					}
				}
			}

			return null;
		}

		function getActivityInstanceTrace() {
			if ($scope.currentActivity != null && $scope.currentActivity.instanceTrace) {
				return $scope.currentActivity.instanceTrace;
			}

			return null;
		}

		function hasFieldChangedByActivity(fieldName) {
			var instanceTrace = getActivityInstanceTrace();
			if (instanceTrace != null) {
				for (var i = 0; i < instanceTrace.fields.length; i++) {
					var fieldTrace = instanceTrace.fields[i];
					if (fieldTrace.fieldName === fieldName) {
						return true;
					}
				}
			}

			return false;
		}

		function showFieldChangesByActivity(fieldName) {
			var instanceTrace = getActivityInstanceTrace();
			if (instanceTrace != null) {
				for (var i = 0; i < instanceTrace.fields.length; i++) {
					var fieldTrace = instanceTrace.fields[i];
					if (fieldTrace.fieldName === fieldName) {

						if (fieldTrace.fieldType === "java.util.Date") {
							if (fieldTrace.newValue != null) {
								fieldTrace.newValue = moment(fieldTrace.newValue).format("DD-MM-YYYY");
							}
							if (fieldTrace.oldValue != null) {
								fieldTrace.oldValue = moment(fieldTrace.oldValue).format("DD-MM-YYYY");
							}
						}

						$mdDialog.show({
							clickOutsideToClose: true,
							parent: angular.element(document.body),
							locals: {
								fieldTrace: fieldTrace,
								field: $scope.entity.form[fieldName]
							},
							controller: "fieldTraceController",
							templateUrl: "/pphhNav/activityDiffDialog"
						});

						return;
					}
				}
			}
		}

		function filterByActivity(value) {
			if ("del" === value) {
				$window.location.href = pphhEnv.global.contextPath + "/pphhNav/activity/"
					+ $scope.currentActivity.id + "/d/" + $scope.entity.entityName;
			} else {
				$scope.entity.filter.fields["_mod_"].value = value;
				doFilter();
			}
		}

		function clearFilterByActivity() {
			$scope.entity.filter.fields["_mod_"].value = null;
			doFilter();
		}

		/**
		 * Muestra la explicación de qué es una actividad.
		 */
		function showActivityHelp() {
			$http.get("/pphhNav/activityHelp")
				.then(
					function(response) {
						var infoDialogData = response.data;
						var infoDialog = $mdDialog.alert()
							.clickOutsideToClose(true)
							.title(infoDialogData.title)
							.htmlContent(infoDialogData.textContent)
							.ok(infoDialogData.ok);

						$mdDialog.show(infoDialog);
					}
				);
		}

		/**
		 * Muestra u oculta la lista de actividades.
		 */
		function showActivityList() {
			$scope.showActivities = !$scope.showActivities;
		}

		/**
		 * Inicia la actividad
		 */
		function startActivity(activity) {
			var url = pphhEnv.global.contextPath + "/pphhNav/activityStart/" + activity.id;
			if (activity.typeId == 1) {
				url += "?entityName=" + activity.entityName;
				url += "&id=" + (activity.instanceId || activity.oldInstanceId);
			}
			$window.location.href = url;
		}

		/**
		 * Cierra la actividad.
		 */
		function closeActivity(url) {
			if (!url) {
				$window.location.href =
					pphhEnv.global.contextPath + "/pphhNav/close-activity"
					+ "?entityName=" + $scope.entity.entityName;
			} else {
				$window.location.href = pphhEnv.global.contextPath + url;
			}
		}

		/**
		 * Realiza la transición dada una determinada acción.
		 */
		function activityTransition(action) {
			$mdDialog.show({
				controller: "pphhNavActivityTransitionController",
				templateUrl: "/pphhNav/activityTransitionDialog",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				locals: {
					action: action,
					instanceData: {
						entityName: $scope.entity.entityName,
						id: $scope.entity.id
					}
				}
			})
				.then(
					function(answer) {
						closeActivity(answer.redirect);
					},
					function(errors) {
						$scope.errorMessages = errors;
					});
		}

		function activityInfo(what) {
			$mdDialog.show({
				clickOutsideToClose: true,
				parent: angular.element(document.body),
				locals: {
					activity: $scope.currentActivity
				},
				controller: "activityInfoController",
				templateUrl: "/pphhNav/activityInfoDialog?w=" + what
			}).then(function(response) {
				$window.location.href = pphhEnv.global.contextPath + "/crud/" + response.entityName;
			});
		}

		function showModuleIndex(moduleName) {
			$mdDialog.show({
				clickOutsideToClose: true,
				controller: "moduleIndexController",
				resolve: {
					module: function() {
						return moduleName;
					}
				},
				templateUrl: "/crud/moduleIndex-init?module=" + moduleName
			});
		}

		/**
		 * Navega a una determinada entidad utilizando un determinado path de navegación.
		 * @param name El nombre de la propiedad que se usa para navegar.
		 * @param externalLink Valor lógico que indica si se trata de un link externo
		 * o no.
		 */
		$scope.navigate = function(name, externalLink) {
			var entity = $scope.entity;
			if (!externalLink) {
				$window.location.href = pphhEnv.global.contextPath + "/crud/" + entity.entityName
					+ "/" + entity.id + "/p/" + name;
			} else {
				var url = pphhEnv.global.contextPath + "/crud/" + entity.entityName
					+ "/" + entity.id + "/l/" + name;
				$window.location.href = url;
			}
		};

		/**
		 * Devuelve true si el campo contiene un link a otro módulo.
		 */
		$scope.fieldWithExternalLink = function(fieldName) {
			var linkDefined = false;
			if ($scope.entity.externals.links) {
				for (var i = 0; !linkDefined && i < $scope.entity.externals.links.length; i++) {
					var link = $scope.entity.externals.links[i];
					linkDefined = link.name === fieldName;
				}
			}
			return linkDefined;
		}

		/**
		 * Navega a la entidad padre.
		 * @param name El nombre de la entidad.
		 * @param id El identificador de la instancia destino.
		 */
		$scope.navigateParent = function(name, id) {
			$window.location.href = pphhEnv.global.contextPath + "/crud/" + name + "/" + id;
		};

		$scope.isPendingDeletion = function() {
			for (var i = 0; i < $scope.activities.length; i++) {
				var activity = $scope.activities[i];
				if (activity.oldInstanceId == $scope.entity.id
					&& activity.action === "D") {
					return true;
				}
			}

			return false;
		};

		/**
		 * Asocias los estilos adecuads a las filas del filtrado en función
		 * de la actividad.
		 */
		function filterResultRowClasses(row) {
			var classes = [];
			
			for (var i = 0; i < $scope.activities.length; i++) {
				var activity = $scope.activities[i];
				if (activity.entityName == $scope.entity.entityName) {
					if (activity.action === "D" &&
						activity.oldInstanceId == row.data.id) {
						classes[classes.length] = "del";

					} else if (activity.action !== "D" &&
						(activity.oldInstanceId == row.data.id ||
							activity.instanceId == row.data.id)) {
						classes[classes.length] = "mod";
					}
				}
			}

			return classes;
		}

		/**
		 * Muestra el diálogo de gestión de los filtros persistentes.
		 */
		function showStoredFilters() {
			$mdDialog.show({
				clickOutsideToClose: true,
				controller: "storedFilterController",
				templateUrl: "/crud/storedFilters",
				locals: {
					storedFilters: $scope.storedFilters,
					waterModule: $scope.waterModule
				}
			}).then(function(response) {
				if (response) {
					var changed = false;
					angular.forEach($scope.entity.filter.fields, function(ele) {
						if (ele.storedFilterKey === response.filter.key) {
							ele.storedFilterKey = null;
							changed = true;
						}
					});

					if (changed) {
						doFilter();
					}
				}
			});
		}

		/**
		 * Limpia el filtro.
		 */
		// TODO Bug al intentar resetear el estado de la tabla
		function clearFilter() {

			angular.forEach($scope.entity.filter.fields, function(field) {
				field.value = null;
				field.upperValue = null;
				field.description = null;
				field.storedFilterKey = null;
				field.comparisionType = null;				
			});

			var form = $scope.filterForm;
			form.$setPristine();

			if ($scope.stCtrl) {
				$scope.filterResults = [];
				var tableState = $scope.stCtrl.tableState();
				// tableState.search.predicateObject = {};
				tableState.pagination.start = 0;
				tableState.pagination.numberOfPages = 0;
				$scope.stCtrl.pipe();
			}
		}

		$scope.textLikeFilter = function(filterName) {
			$scope.setComparisionType(filterName, 'iLIKE');
			filter();
		};

		$scope.setComparisionType = function(filterName, op) {
			$scope.entity.filter.fields[filterName].comparisionType = op;
			return true;
		};

		/** desactiva el filtro vacio */
		function  limpiarVacio ( filterName, op ){
			if ( $scope.entity.filter.fields[filterName].comparisionType === "isNULL" )
			{
				$scope.entity.filter.fields[filterName].value = null;
				$scope.entity.filter.fields[filterName].description = null;
			}
			$scope.setComparisionType(filterName, op);
		}
		/** Activa y desactiva el filtro de campo vacio. Op contendra la operacion a poner cuando no es filtro vacio.*/
		function filtroVacio ( filterName, op, value  ){

			if ( $scope.entity.filter.fields[filterName].comparisionType === "isNULL"){
				limpiarVacio (filterName, op)
			}else{
				$scope.setComparisionType(filterName, "isNULL");
				$scope.entity.filter.fields[filterName].value=value;
				$scope.entity.filter.fields[filterName].description='Vacio';
			}
			filter();
		}
		/**
		 * Método que se encarga de realizar el filtrado sobre la entidad.
		 */
		function filter() {
			$scope.expandFilters(false);

			var tableState = $scope.stCtrl.tableState();
			SmartTableUtils.reset(tableState);

			$scope.stCtrl.pipe();
		}

		function findStoredFilterById(key) {
			var storedFilter = null;
			for (var i = 0; i < $scope.storedFilters.length; i++) {
				var ele = $scope.storedFilters[i];
				if (ele.key === key) {
					storedFilter = ele;
					break;
				}
			}
			return storedFilter;
		}

		function findStoredFilterByEntityName(entityName) {
			var storedFilter = null;
			for (var i = 0; i < $scope.storedFilters.length; i++) {
				var ele = $scope.storedFilters[i];
				if (ele.entityName === entityName) {
					storedFilter = ele;
					break;
				}
			}
			return storedFilter;
		}

		function findStoredFilterByFilterField(filterField) {
			if (!filterField) {
				return [];
			}

			var validStoredFilters = filterField.validStoredFilters;
			var filters = [];
			for (var i = 0; i < $scope.storedFilters.length; i++) {
				var ele = $scope.storedFilters[i];
				if (validStoredFilters.indexOf(ele.entityName) !== -1) {
					filters.push(ele);
				}
			}
			return filters;
		}

		function applyStoredFilter(storedFilter, filterField) {
			filterField.storedFilterKey = storedFilter.key;
			filterField.value = null;
			filter();
		}

		function clearStoredFilter(filterField) {
			filterField.storedFilterKey = null;
			filter();
		}

		function storeFilter() {
			$mdDialog.show({
				clickOutsideToClose: true,
				controller: "newStoredFilterController",
				templateUrl: "/crud/storedFilters/new"
			}).then(function(response) {
				$scope.isLoading = true;

				var entityName = $scope.entity.entityName;
				var filterFields = $scope.entity.filter.fields;
				return crudService.storeFilter(response.name, entityName, filterFields);
			}).then(
				function(response) {
					$scope.isLoading = false;
					$scope.storedFilters.push(response.data);
				}, function() {
					$scope.isLoading = false;
				});
		}

		/**
		 * Lanza el filtrado sobre la entidad.
		 */
		function doFilter(tableState, ctrl) {
			if (initializing) {
				registerPostInitActions({
					fn: doFilter,
					params: [tableState, ctrl]
				});
				return;
			}

			if (!$scope.stCtrl && ctrl) {
				$scope.stCtrl = ctrl;
			}

			if (!tableState && $scope.stCtrl) {
				$scope.stCtrl.pipe();
				return;
			}

			if ($scope.filterForm && !$scope.filterForm.$valid) {
				return;
			}

			$scope.isLoading = true;

			var start = 0;
			var sort = null;
			if (presetPaginationStart) {
				start = presetPaginationStart;
				presetPaginationStart = null;
			}
			else {
				var pagination = tableState.pagination;
				start = pagination.start || 0;
			}
			// var search = tableState.search.predicateObject;
			if (presetSort) {
				sort = presetSort;
				presetSort = null;
			}
			else {
				sort = tableState.sort;
			}

			var filterSuccessCallback = function(response) {
				$scope.filterResults = response.resultados.results;
				$scope.menusResults = response.menus;
				$scope.pageSize = response.resultados.pageSize;
				SmartTableUtils.updateTableState(tableState, response.resultados);
				tableState.sort = sort;

				$scope.isLoading = false;
			};

			var filterErrorCallback = function() {
				$mdDialog.show(
					$mdDialog.alert({
						title: UIMessages.dialog.confirm.title,
						textContent: "Error filter",
						ok: UIMessages.dialog.confirm.cerrar
					}));
				$scope.isLoading = false;
			}

			var entityName = $scope.entity.entityName;
			var filterFields = angular.copy($scope.entity.filter.fields );
			// Asginamos valor los campos filtrado por isNULL
			angular.forEach(filterFields, function(filterField, filterFieldName) {
				if ( filterField.comparisionType ==="isNULL"){
					filterField.value = "Vacio";				}
			});
			crudService.filter(entityName, filterFields, start, sort)
				.then(filterSuccessCallback, filterErrorCallback);
		}

		/**
		 * Navega a una instancia de una entidad.
		 */
		$scope.navigateInstance = function(entityName, id, actId) {
			var url = pphhEnv.global.contextPath + "/crud/" + entityName + "/" + id;
			if (actId) {
				url += "?actId=" + actId;
			}
			$window.location.href = url;
		};


		/**
		 * Cambia el modo de vista.
		 */
		function changeViewMode() {
			crudService.changeViewMode($scope.entity.entityName, !$scope.entity.readonly,$scope.entity.id)
				.then(function(response) {
					$scope.entity.readonly = response.data;
				}, function(response){
					$scope.entity.readonly = true;
					var alert = $mdDialog.alert({
						textContent: response.data.errorMessages[0].message,
						ok: UIMessages.dialog.confirm.cerrar,
						clickOutsideToClose: true
					});
					$mdDialog.show(alert);
				});
		}

		function initNew() {
			$window.location.href = pphhEnv.global.contextPath + "/crud/" + $scope.entity.entityName + "?new=1";
		}

		/**
		 * Cancela la edición en el alta y resetea los valores en la modificación.
		 */
		$scope.cancelEdition = function() {

			var index = $scope.breadcrumbs.length - 1;

			if ($scope.entity.id != null) {
				index = $scope.breadcrumbs.length - 2;
				if (index < 0) {
					index = 0;
				}
			}

			var lastBreadCrumb = $scope.breadcrumbs[index];
			$window.location.href = pphhEnv.global.contextPath + lastBreadCrumb.link;
		};

		$scope.showFieldInlineHelp = function(fieldName) {
			var field = $scope.entity.form[fieldName];
			if (field.inlineHelp) {
				var alert = $mdDialog.alert({
					textContent: field.inlineHelp,
					ok: UIMessages.dialog.confirm.cerrar,
					clickOutsideToClose: true
				});
				$mdDialog.show(alert);
			}
		};

		$scope.isReadOnlyFormField = function(fieldName) {
			return $scope.entity.readonly
				|| $scope.entity.form[fieldName].virtual
				|| $scope.entity.form[fieldName].readonly;
		};

		$scope.isVirtualFormField = function(fieldName) {
			return $scope.entity.form[fieldName].virtual;
		};

		$scope.clearLookupField = function(fieldName) {
			var field = $scope.entity.form[fieldName];
			field.value = null;
			field.description = null;
		};
		
        $scope.openModalUpload = function(fieldName) {
			
			$mdDialog.show({
                clickOutsideToClose: false,
                parent: angular.element(document.body),
                controller: "uploadImagenController",
				templateUrl: "/crud/sourceDialog-imagenInit/" 
							+ $scope.entity.entityName + "/" + fieldName + "/" +$scope.entity.id
							});
		};

		/**
		 * Función que permite buscar sobre la fuente de datos utilizada por un
		 * campo como si de un combo se tratase.
		 */
		function lookupSource(fieldName, callback) {
			if ($scope.currentViewType === "formView" && $scope.isReadOnlyFormField(fieldName)) {
				return;
			}

			$mdDialog.show({
				clickOutsideToClose: true,
				controller: "lookupSourceControllerDispatcher",
				parent: angular.element(document.body),
				resolve: {
					entity: function() {
						return $scope.entity;
					},
					fieldName: function() {
						return fieldName;
					},
					multiple: function() {
						return $scope.currentViewType === "listView";
					},
					selectedValues: function() {
						var id = null;
						var description = null;
						if ($scope.currentViewType === "listView") {
							id = $scope.entity.filter.fields[fieldName].value;
							description = $scope.entity.filter.fields[fieldName].description;
						}

						var selectedValues = [];
						for (var i = 0; id && i < id.length; i++) {
							selectedValues[selectedValues.length] = {
								id: id[i],
								value: description[i]
							};
						}
						return selectedValues;
					},
					currentViewType: function() {
						return $scope.currentViewType;
					}
				},
				templateUrl: "/crud/sourceDialog-init/"
					+ $scope.entity.entityName + "/" + fieldName
			})
				.then(
					function(selected) {
						if (!selected) {
							return;
						}

						if (selected.length === 0) {
							if ($scope.currentViewType === "listView") {
								$scope.entity.filter.fields[fieldName].value = null;
								$scope.entity.filter.fields[fieldName].description = null;
							}
							else {
								$scope.entity.form[fieldName].value = null;
								$scope.entity.form[fieldName].description = null;
							}
						} else {
							var id = [];
							var description = [];
							for (var i = 0; i < selected.length; i++) {
								id[id.length] = selected[i].id;
								description[description.length] = selected[i].value;
							}
							if ($scope.currentViewType === "listView") {
								$scope.entity.filter.fields[fieldName].value = id;
								$scope.entity.filter.fields[fieldName].description = description;
							}
							else {
								$scope.entity.form[fieldName].value = id[0];
								$scope.entity.form[fieldName].description = description[0];
							}
						}

						if (callback) {
							callback();
						}
					}
				);
		}

		$scope.download = function() {
			var tableState = $scope.stCtrl.tableState();
			var sort = tableState.sort;
			var filterFields = angular.copy($scope.entity.filter.fields );
			// Asginamos valor los campos filtrado por isNULL
						angular.forEach(filterFields, function(filterField) {
							if ( filterField.comparisionType ==="isNULL"){
								filterField.value = "Vacio";				}
						});
			crudService.download($scope.entity.entityName, filterFields, sort);
		};

		/**
		 * Cierra el visor del plan
		 */
		$scope.close = function() {
			var url = pphhEnv.global.contextPath + "/crud/close";
			$window.location.href = url;
		};


		/**
		 * Ejecuta la acción del menú general
		 */
		function executeMenuOption(controllerName) {
			var controller = $injector.get(controllerName);
			var promise = controller.performAction($scope);
			/*
			 * Si no devuelve un objeto promise se da por supuesto
			 * que la acción no altera el menú.
			 */
			if (promise != null) {
				promise.then(
					function() {
						loadModuleGlobalMenu();
					});
			}
		}



		$scope.isGisAvailable = function(row) {
			return $scope.currentActivity == null
				&& ('surfacewb' === $scope.entity.entityName
					|| 'groundwb' === $scope.entity.entityName
					|| 'rbd' === $scope.entity.entityName
					|| 'surfacewbassoprotarea' === $scope.entity.entityName
					|| 'gwbassocpa' === $scope.entity.entityName
					|| 'monisite' === $scope.entity.entityName
					|| ('medidas' === $scope.entity.entityName
						&& row.latitudEtrs89 != null
						&& row.longitudEtrs89 != null))
		};

		/* Manu: mantener temporalmente
		$scope.showGis = function (row) {
			var url = pphhEnv.global.contextPath + "/gisDialog";

			if($scope.entity.entityName === "surfacewb") {
				url += "?origen=SWB";
			} else if($scope.entity.entityName === "groundwb") {
				url += "?origen=GWB";
			} else if($scope.entity.entityName === "medidas") {
				url += "?origen=MED";
			}
			url += "&id=" + row.id;

			var key = null;
			var description = null;
			var point = null;
			if($scope.entity.entityName === "surfacewb") {
				key = row.euSurfaceWaterBodyCode;
				description = row.surfaceWaterBodyName;
			} else if($scope.entity.entityName === "groundwb") {
				key = row.euGroundWaterBodyCode;
				description = row.groundwaterBodyName;
			} else if($scope.entity.entityName === "medidas") {
				key = row.euCode;
				description = row.descripcionMedida;
				point = {
					latitud: row.latitudEtrs89,
					longitud: row.longitudEtrs89
				};
			}

			$mdDialog.show({
				clickOutsideToClose: true,
				parent: angular.element(document.body),
				locals: {
					instance: {
						key: key,
						description: description,
						point: point
					}
				},
				controller: GisDialogController,
				template:
					'<md-dialog ng-init="init()">'
					+ '<md-dialog-content> '
					+ '<div class="md-dialog-content">'
					+ '  <div>'
					+ '    <p>{{instance.key}}</p>'
					+ '    <p>{{instance.description}}</p>'
					+ '  </div>'
					+ '  <div>'
					+ '    <iframe src="' + url + '" height="1024" width="768"></iframe>'
					+ '  </div>'
					+ '</div>'
					+ '</md-dialog-content>'
					+ '</md-dialog>'
			});

			function GisDialogController(instance) {
				$scope.instance = instance;

				$scope.init = function () {

				};
			}
		};
		*/

		function showModuleCarousel() {
			$mdDialog.show({
				clickOutsideToClose: true,
				controller: "moduleCarouselController",
				templateUrl: "/crud/moduleCarousel"
			});
		}

		/**
		 * Devuelve el menú asociado a la fila del registro.
		 */
		function getRowMenu(row) {
			if ($scope.menusResults[row.data.id]) {
				return $scope.menusResults[row.data.id].items;
			}

			return [];
		}

		/**
		 * Ejecuta la acción del menú de cada fila
		 */
		function executeRowMenuOption(controllerName, row, actionParams) {
			var controller = $injector.get(controllerName);
			var promise = controller.performAction($scope, row.data, actionParams);
			/*
			 * Si no devuelve un objeto promise se da por supuesto
			 * que la acción no altera el resultado de la consulta.
			 */
			if (promise != null) {
				promise.then(
					function() {
						doFilter()
					});
			}
		}
	}

	function ModuleIndexController($scope, $window, $http, pphhEnv, module) {
		$scope.init = init;
		$scope.gotoEntity = gotoEntity;
		$scope.selectDiagram = selectDiagram;
		$scope.search = search;

		function init() {
			$http({
				method: "GET",
				url: "/crud/module/" + module + "/index"
			}).then(
				function(response) {
					var folderName = module.replace('.', '_');
					var moduleIndex = response.data;
					angular.forEach(moduleIndex.diagrams, function(diagram) {
						var src = pphhEnv.global.contextPath + "/static/img/module/" + folderName + "/" + diagram.src;
						diagram.src = src;
					});

					/**
					 * Aplica solo a modulo "hidromorfologicas"
					 * Asigna como hijo un skeleton si (segun vengan ordenados) esta dentro de 
					 * las compositions de un padre anterior en la iteracion.
					 */
					if(moduleIndex.group == 'pi.hidromorfologicas') {
						var skeletonPadre = null;
						angular.forEach(moduleIndex.skeletons, function(skeleton) {
							if(skeletonPadre != null && skeletonPadre.compositions.length > 0) {
								if(skeletonPadre.compositions.some(e => e.name === skeleton.entityName+'s')){
									skeleton.isChild = true;
								}
							}
							if(!skeleton.isChild) {
								skeletonPadre = skeleton;	
							}
						});
					}
					$scope.moduleIndex = moduleIndex;

					if (moduleIndex.diagrams.length > 0) {
						moduleIndex.diagrams[0].open = true;
					}
				});
		}

		function gotoEntity(entityName) {
			$window.location.href = pphhEnv.global.contextPath + "/crud/" + entityName;
		}

		function selectDiagram(diagram) {
			diagram.open = !diagram.open;
		}

		function search(item) {
			if (angular.isUndefined($scope.entityNameFilter)) {
				return true;
			} else {
				var loweredFilter = $scope.entityNameFilter.toLowerCase();
				return item.entityDisplayLabel.toLowerCase().indexOf(loweredFilter) >= 0
					|| item.entityAltDisplayLabel.toLowerCase().indexOf(loweredFilter) >= 0;
			}
		}
	}

	function LookupSourceControllerDispatcher($scope, $controller, $mdDialog, $http,
		entity, fieldName, multiple, selectedValues, currentViewType) {
		var dialogController = "CRUDSourceDialogController";
		var customController = null;
		if (currentViewType === "formView") {
			customController = entity.form[fieldName].sourceController;
		} else {
			customController = entity.filter.fields[fieldName].sourceController;
		}
		if (customController) {
			dialogController = customController;
		}

		$controller(dialogController, {
			"$scope": $scope,
			"$mdDialog": $mdDialog, "$http": $http, "entity": entity, "fieldName": fieldName,
			"multiple": multiple, "selectedValues": selectedValues, "currentViewType": currentViewType
		});
	}

	function StoredFilterController($scope, $mdDialog, crudService, storedFilters, waterModule) {
		$scope.storedFilters = storedFilters;

		$scope.changeGlobalFeature = function(storedFilter) {
			for (var i = 0; i < $scope.storedFilters.length; i++) {
				if ($scope.storedFilters[i] === storedFilter && !storedFilter.global
					&& storedFilter.moduleName !== waterModule.key) {
					$scope.storedFilters.splice(i, 1);
					break;
				}
			}

			crudService.changeGlobalFeature(storedFilter);
			$mdDialog.hide({
				action: "changeGlobalFeature",
				filter: storedFilter
			});
		};

		$scope.removeStoredFilter = function(storedFilter) {
			for (var i = 0; i < $scope.storedFilters.length; i++) {
				if ($scope.storedFilters[i] === storedFilter) {
					$scope.storedFilters.splice(i, 1);
					break;
				}
			}

			crudService.deleteStoredFilters(storedFilter);
			$mdDialog.hide({
				action: "delete",
				filter: storedFilter
			});
		};
	}

	function NewStoredFilterController($scope, $mdDialog) {
		$scope.save = function() {
			if (!$scope.persistFilterForm.$valid) {
				return;
			}

			$mdDialog.hide({
				name: $scope.name
			});
		}

		$scope.cancel = function() {
			$mdDialog.cancel();
		}
	}

	function ModuleCarouselController($scope, crudService) {

		$scope.init = function() {
			crudService.moduleCarousel()
				.then(function(response) {
					$scope.carousel = response.data;
				});
		};

		$scope.navigateTo = function(waterModule) {
			crudService.switchModuleCarousel(waterModule.key);
		};
	}

	function ActivityInfoController($scope, $mdDialog, activity) {

		$scope.activity = activity;

		$scope.navigate = function(entityName) {
			$mdDialog.hide({
				entityName: entityName
			});
		};
	}

	function FieldTraceController($scope, fieldTrace, field) {

		if (field.fieldClass === 'java.lang.Boolean') {
			if (fieldTrace.oldValue === 0) {
				fieldTrace.oldValue = UIMessages.crud.no;
			} else if (fieldTrace.oldValue === 1) {
				fieldTrace.oldValue = UIMessages.crud.yes;
			}
			if (fieldTrace.newValue === 0) {
				fieldTrace.newValue = UIMessages.crud.no;
			} else if (fieldTrace.newValue === 1) {
				fieldTrace.newValue = UIMessages.crud.yes;
			}
		}

		$scope.fieldTrace = fieldTrace;
		$scope.field = field;
	}

	App.directive("medidaEuCode", function() {
		return {
			require: "ngModel",
			restrict: "A",
			link: function(scope) {
				var updateEuCode = function(rbd) {
					var euCode = scope.entity.form.euCode;
					if (euCode.value && euCode.value.match(/^.{5}_[0-9]+_.+$/)) {
						return;
					}
					if (rbd
						&& (!euCode.value || euCode.value.match(/^.{5}_+$/))) {
						scope.entity.form.euCode.value = (rbd.substring(0, 5) + "_").toUpperCase();
					}
				}

				scope.$watch("entity.form.rbd.value", function() {
					if (scope.entity.form.rbd) {
						updateEuCode(scope.entity.form.rbd.description);
					}
				});
			}
		};
	});

	App.directive("medidaAmbitoTerIg", function() {
		return {
			require: "ngModel",
			restrict: "A",
			link: function(scope) {
				scope.$watch("entity.form.subtipoAmbitoIg.value", function(val) {
					var props = {
						"comunidadAutonoma": 1,
						"municipio": 2,
						"provincia": 4,
						"cuenca": 5,
						"subsistemaExplotacion": 7,
						"subzona": 8,
						"sistemaExplotacion": 9,
						"zona": 10,
						"isla": 11,
						"zonaProtegida": 12
					};

					for (var prop in props) {
						if (props.hasOwnProperty(prop)) {
							var field = scope.entity.form[prop];
							if (!field) {
								continue;
							}
							if (props[prop] == val) {
								field.visible = true;
								field.mandatory = true;
							} else {
								field.visible = false;
								field.mandatory = false;
							}
						}
					}
				});
			}
		};
	});

	App.directive("medidaAmbitoTerIgFilter", function() {
		return {
			require: "ngModel",
			restrict: "A",
			link: function(scope) {
				scope.$watch("entity.filter.subtipoAmbitoIg.value", function(val) {
					var props = {
						"comunidadAutonoma": 1,
						"municipio": 2,
						"provincia": 4,
						"cuenca": 5,
						"subsistemaExplotacion": 7,
						"subzona": 8,
						"sistemaExplotacion": 9,
						"zona": 10,
						"isla": 11,
						"zonaProtegida": 12
					};

					var descripcionAmbitoFilter = scope.entity.filter["descripcionAmbito"];
					if (descripcionAmbitoFilter ){
						descripcionAmbitoFilter.visible = false;

						for (var prop in props) {
							if (props.hasOwnProperty(prop)) {
								var field = scope.entity.filter[prop];
								if (!field) {
									continue;
								}
								if (props[prop] == val) {
									field.visible = true;
									field.mandatory = true;
	
									descripcionAmbitoFilter.visible = true;
								} else {
									field.visible = false;
									field.mandatory = false;
								}
							}
						}
					}
				});
			}
		};
	});


	App.directive("obrasIgAmbitoTerIg", function() {
		return {
			require: "ngModel",
			restrict: "A",
			link: function(scope) {
				scope.$watch("entity.form.subtipoAmbitoIg.value", function(val) {
					var props = {
						"comunidadAutonoma": 1,
						"municipio": 2,
						"provincia": 4,
						"cuenca": 5,
						"subsistemaExplotacion": 7,
						"subzona": 8,
						"sistemaExplotacion": 9,
						"zona": 10,
						"isla": 11,
						"zonaProtegida": 12
					};

					for (var prop in props) {
						if (props.hasOwnProperty(prop)) {
							var field = scope.entity.form[prop];
							if (!field) {
								continue;
							}
							if (props[prop] == val) {
								field.visible = true;
								field.mandatory = true;
							} else {
								field.visible = false;
								field.mandatory = false;
							}
						}
					}
				});
			}
		};
	});
	

	/**
	 * Clase que controla el diálogo de carga de recursos de ayuda
	 */
	function UploadImagenController($scope, $mdDialog, crudservice) {
		
		$scope.closeButton = true;
		
		$scope.closeDialog = closeDialog;
		$scope.closeDialogOk = closeDialogOk;
		$scope.uploadImagenFile = uploadImagenFile;
		
		function closeDialog() {
			$mdDialog.hide();
		}

		function closeDialogOk() {
			$mdDialog.hide(true);
		}

		function uploadImagenFile() {
			
			var file = $scope.file;
			var id = $scope.id;
			var uploadFileSuccessCallback = function(response) {
				var messages = response.messages;
				var field = messages[0];
				$scope.message = field.message;
				$scope.closeButton = false;
				
			};

			var uploadFileErrorCallback = function(response) {
				var errorMessages = response.errorMessages;
				if (errorMessages != null) {
					var field = errorMessages[0];
					$scope.message = field.message;
				} else {
					$scope.message = UIMessages.global.errorInesperado;
				}
				$scope.closeButton = false;
			};
			
			crudservice.uploadImagenFile(file, id, $scope.entityName,$scope.fieldName).then(
					uploadFileSuccessCallback, uploadFileErrorCallback);
		}
	}
})();